import { useThorView } from "@aviv-dxp/react-thor";
import { useTrackingDatas } from "./useTracking";
import { useEffect } from "react";
import { useAuthContext } from "@/contexts/auth";
import { useConfig, useEnv, useTrackingSite } from "@/contexts/cdpConfig";
import { IS_SERVER } from "@/constants";
import { getUrlPath } from "@/utils";
export const useTrackingViewCallback = (active) => {
    const { verifiedToken, authTrackingData } = useAuthContext();
    const env = useEnv();
    const site = useTrackingSite();
    const isPreviewMode = useConfig().previewMode;
    // The ab-test variant value is kept for future use
    const abtestVariant = "";
    const viewProps = {
        ...useTrackingDatas(),
        av_environment: env,
        av_user: authTrackingData,
        av_platform: "web",
        av_url_path: getUrlPath(),
        av_site: site,
        av_pagetitle: "classified_detail_callback",
        av_abtest_variant: abtestVariant,
    };
    // view object is subject to change so it's not listed as dep (to avoid sending the event twice)
    const view = useThorView({ viewProps });
    // ThorEvent object is subject to change (so it's not listed as dep)
    useEffect(() => {
        if (active && !IS_SERVER && verifiedToken && !isPreviewMode) {
            view();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, IS_SERVER, verifiedToken]);
};
